import React from 'react';
import PropTypes from 'prop-types';
import ComponentBadgeImage from 'components/component-badge-view';
import DirectionsImage from 'static/images/directionsIcon.png';
import classes from './user-invitation.scss';
import {
  defineMessages,
  FormattedMessage,
  FormattedHTMLMessage,
  useIntl,
} from 'react-intl';


const t = defineMessages({
  'user-invitation.icon-text': {
    id: 'user-invitation.icon-text',
    defaultMessage: 'User invitation icon',
    description: 'Hover text to display for the user invitation image',
  },
  'user-invitation.sign-in': {
    id: 'user-invitation.sign-in',
    defaultMessage: 'Sign In',
    description: 'Label for the sign in button',
  },
  'user-invitation.title': {
    id: 'user-invitation.title',
    defaultMessage: 'Sign in to view the invitation',
    description: 'User invitation page title',
  },
  'user-invitation.body-text-p1': {
    id: 'user-invitation.body-text-p1',
    defaultMessage: 'You\'ve been invited to join another account. For more details about your LogMeIn products, sign in info, and account admin, check your invitation email.',
    description: 'Paragraph 1 of body text',
  },
  'user-invitation.body-text-p2': {
    id: 'user-invitation.body-text-p2',
    defaultMessage: 'Been a while since you signed in? We can help you <a href="{resetPwdURL}" target="_self" rel="noopener noreferrer">reset your password</a>.',
    description: 'Paragraph 2 of body text',
  },
});

const UserInvitation = ({
  navToSignIn,
  resetPwdUrl,
}) => {
  const intl = useIntl();
  return (
    <div>
      <ComponentBadgeImage
        iconURL={DirectionsImage}
        title={intl.formatMessage(t['user-invitation.icon-text'])}
      />
      <div id="user-invitation-section" className={classes['userInvitationContainer']}>
        <form>
          <div className={`row ${classes['titleRow']}`}>
            <div className="col-xs-12">
              <h1 className={classes['titleText']}>
                <FormattedMessage {...t['user-invitation.title']} />
              </h1>
            </div>
          </div>
          <div className={`row ${classes['bodyRow']}`}>
            <div className="col-xs-12">
              <p className={classes['bodyText']}>
                <FormattedMessage {...t['user-invitation.body-text-p1']} />
              </p>
            </div>
          </div>
          <div className={`row ${classes['bodyRow']}`}>
            <div className="col-xs-12">
              <p className={classes['bodyText']}>
                <FormattedHTMLMessage {...t['user-invitation.body-text-p2']} values={{resetPwdURL: resetPwdUrl}} />
              </p>
            </div>
          </div>
          <div className={`row ${classes['buttonRow']}`}>
            <div className="col-xs-6">
              <button
                id="user-invitation-signin"
                type="button"
                className="btn btn-default ninety-button marginl-5"
                onClick={navToSignIn}
              >
                <FormattedMessage {...t['user-invitation.sign-in']} />
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

UserInvitation.propTypes = {
  navToSignIn: PropTypes.func.isRequired,
  resetPwdUrl: PropTypes.string.isRequired,
};

export default UserInvitation;
